import { makeAutoObservable } from "mobx";
import { ProvisionEquipmentSensorListItem } from "features/provisioning/provisions/models/provision-models";
import { getProvisionSensorsForAsset } from "features/provisioning/provisions/services/provision-event-service";

class SensorStockStore {
  stockSensors: ProvisionEquipmentSensorListItem[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  loadAvailableSensors = async (assetId: string) => {
    await getProvisionSensorsForAsset(assetId)
    this.stockSensors = await getProvisionSensorsForAsset(assetId);
    return this.stockSensors;
  }

}

const sensorStockStore = new SensorStockStore();
export default sensorStockStore;